import CloseAccountPage from './CloseAccountPage';
import './CloseAccountPage.css';

export default CloseAccountPage;



// WEBPACK FOOTER //
// ./src/pages/Account/components/CloseAccountPage/index.js